import { Component, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl, SafeHtml } from '@angular/platform-browser';

import {ActivatedRoute, Router} from '@angular/router';
import { NetworkHelperService } from '../../../_services/network-helper.service';
import {FORMS, API, CODFUNC, GENERALES, PAGE} from '../../../_config/strings';

import {Usuario} from '../../../_model/Usuario';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import {Subject} from 'rxjs/Subject';
import { ChatService } from '../../../_services/chat.service';

declare var $: any;

@Component({
  selector: 'app-listar-abastecimiento',
  templateUrl: './listar-abastecimiento.component.html',
  styleUrls: ['./listar-abastecimiento.component.scss'],
})

export class ListarAbastecimientoComponent implements OnInit {

    // Propiedades de dataTable
  dtOptions: DataTables.Settings = {
    pageLength: 10,
    lengthChange: false,
    info: false
  };
  dtTrigger: Subject<any> = new Subject();

  FORMS: any;
  API: any;
  GENERALES: any;
  PAGE: any;
  // Permisos en botón
  botonesPermisos = {
    crearAbastecimiento: false,
  };

  idCliente: any;
  urlContrato: any;
  loginLoader = false;
  btnRegistrarContrato = false;

  public usuario: Usuario = new Usuario();
  public innerHtml: SafeHtml;

    pay: string = 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf';
    pdfSrc: string;


  clientesArray = [];
  contratosArray = [];
  arrayUsuarios = [];
  // Formulario
  contrato = '';
  fechaInicio = '';
  fechaFin = '';
  dias = '';
  documento = '';
  // nombreCliente = '';
  // paternoCliente = '';
  // maternoCliente = '';
  // nombreCompleto = '';
  // rfc = '';
  // tipoDeCliente = '';
  estatusDocumentoNombre = '';
  estatusDocumentoColor = '';
  estatusDocumentoEstatus = '';
  estatusDocumentoId;
  estatusNombre = '';
  estatusColor = '';
  documentoRuta = '';
  tipoDeContrato = '';
  incremento = 1;
  // contratoInfo = [];
  permisosArray = [];
  iconoForma = '';
  iconoColor = '';
  // idContrato = '';
  globalFecha = '';
  globalConcepto = '';
  diasAlquiler = '';

  public imageSrc: string;
  public currentIdDocumento: any;
  public currentComentariosDocumento = [];
  public currentMensajeComentarioPopUp = '';
  public enviandoMensajeComentarioPopUp = false;
  deshabilitarCamposPermisoEditar = true;
  btnAutorizarCliente = false;
  btnAlquiler = false;
  btnProrroga = false;
  btnPermitirProrroga = false;
  btnPermitirUnaProrroga = false;
  btnActualizarContrato = false;

  mostrarBotones = [{
    autorizarClienteBtn: false,
    autorizarDocumentoBtn: false,
    popUpHeaderText: '',
    estatus: ''
  }];
  // Array para realizar reverse en dataTable
  clientesArrayReverse = [];
  // Comentarios
  comentariosContratoArray = [];
  visto = false;
  // fechaHoy = moment().subtract('days', 40).format('DD-MM-YYYY');
  // fechaHoy = moment().add('days', 20).format('YYYY-MM-DD');
  fechaHoy;

  constructor(
    private route: ActivatedRoute,
    private network: NetworkHelperService,
    private ruta: Router,
    private chat: ChatService,
    private sanitizer: DomSanitizer
  ) {
    // this.idCliente = this.route.snapshot.paramMap.get('id');
    this.FORMS = FORMS;
    this.API = API;
    this.PAGE = PAGE;
    this.GENERALES = GENERALES;
    this.usuario = JSON.parse( localStorage.getItem('usuario') );
    this.route.params.take(1).subscribe((params: any) => {
      this.idCliente = params['id'];
      this.urlContrato = params['idContrato'];
    });
  }

  ngOnInit() {
    this.getPermisos();
    
    this.detallesContrato();
    this.inverse();
    setTimeout(() => {this.getUsuarios(); this.getAbastecimientos(); }, 1000);
    // this.btnProrroga = true;
    // Datatable
    /*
    $('#dataTableAbastecimientos').dataTable( {
        paging: false,
        searching: false,
        language: {
            searchPlaceholder: 'Aún no tienes abastecimientos'
        }
    });
    */
  }

  getPermisos() {
    const peticion = {
        userId: this.usuario.userId,
        codigoFuncionalidad: 'CLIVER'
    };
    this.network.callSecureService(
        this.API.user.permisosFuncionalidad,
        'POST',
        peticion )
        .subscribe((response: any) => {
                // console.log(response);
                this.permisosArray = response.Mensaje;
                this.mostrarBotonesAbastecimiento();
                const editarCliente = this.permisosArray.find( permiso => permiso === 'CLIEDIT' );
                const autorizarClientePermiso = this.permisosArray.find( permiso => permiso === 'CLIAUTO' );
                const actualizarContrato = this.permisosArray.find( permiso => permiso === 'CONEDIT' );
                if (editarCliente) {
                    this.deshabilitarCamposPermisoEditar = false;
                }
                if (autorizarClientePermiso) {
                    this.btnAutorizarCliente = true;
                }
                if (actualizarContrato) {
                    this.btnActualizarContrato = true;
                } else {
                    this.btnActualizarContrato = false;
                }
            }, err => {
                console.log(err);
                this.mostrarBotonesAbastecimiento();
                Swal('Error', this.GENERALES.algoOcurrio, 'error');
            }
        );
    }

    // Foto de perfil
    getUsuarios() {
        this.network.callSecureService(
            'usuarios' + '/all',
            'GET',
            null)
            .subscribe((response: any) => {
                console.log(response);
                for (const user of response.Mensaje) {
                    this.arrayUsuarios.push({
                        id: user.id,
                        nombre: user.nombre,
                        username: user.username,
                        puesto: user.puesto,
                        sucursal: user.sucursal,
                        imagen: this.API.imagenPerfil + '/' + user.imagen
                    });
                }
            }, err => {
                console.log(err);
                if (err.error.code === 401) {
                    console.log('entro en id de codigo');
                    location.href = '/login';
                }}
            );
    }
    // Foto de perfil

    detallesContrato() {
        this.comentariosContratoArray = [];
        this.enviandoMensajeComentarioPopUp = false;
        this.network.callSecureService(
        this.API.user.clientes + '/' + this.idCliente + '/' + this.API.user.contratos + '/' + this.urlContrato,
        'GET',
        null)
        .subscribe((response: any) => {
            console.log(response);
            if (response.Estatus === 200) {
                this.contrato = response.Mensaje.noContrato.noContrato;
                this.estatusDocumentoId = response.Mensaje.noContrato.idContrato;
                this.fechaInicio = response.Mensaje.noContrato.fechaInicio.split('T')[0];
                this.fechaFin = response.Mensaje.noContrato.fechaFin.split('T')[0];
                this.dias = response.Mensaje.noContrato.dias;
                this.estatusNombre = response.Mensaje.cliente.estatus.nombre;
                this.estatusColor = response.Mensaje.cliente.estatus.color;
                this.documentoRuta = response.Mensaje.noContrato.ruta;
                this.estatusDocumentoNombre = response.Mensaje.noContrato.estatus.nombre;
                this.estatusDocumentoColor = response.Mensaje.noContrato.estatus.color;
                this.estatusDocumentoEstatus = response.Mensaje.noContrato.estatus.estatus;
                // console.log( 'Días de contrato' + this.dias );
                // Comentarios
                this.comentariosContratoArray = response.Mensaje.noContrato.comentarioContrato;
                let comentario = response.Mensaje.noContrato.comentarioContrato.find(elemento => elemento.visto === false );
                if ( comentario ) {
                    this.visto = true;
                }
                // this.tipoDeContrato = this.documentoRuta.split('.')[1];
                let longitud: any;
                longitud = this.documentoRuta.split('.');
                this.tipoDeContrato = longitud[longitud.length - 1] ;
                // Control de botones de abastecimientos
                if ( this.estatusDocumentoEstatus === 'AUTCOMP' || this.estatusDocumentoEstatus === 'AUTSINF') {
                    this.btnRegistrarContrato = true;
                    // document.getElementById('titulo').style.opacity = '0';
                } else {
                    this.btnRegistrarContrato = false;
                }
                // Switch
                switch ( this.estatusDocumentoEstatus ) {
                    case 'AUTCOMP': {
                        this.iconoForma = 'mdi mdi-checkbox-multiple-marked-circle';
                        this.iconoColor = 'springgreen';
                    break;
                    }
                    case 'AUTPEND': {
                        this.iconoForma = 'mdi mdi-alert-box';
                        this.iconoColor = 'orange';
                    break;
                    }
                    case 'AUTDENE': {
                        this.iconoForma = 'mdi mdi-close-box';
                        this.iconoColor = 'red';
                    break;
                    }
                    case 'NOTEXIS': {
                        this.iconoForma = 'mdi mdi-close-outline';
                        this.iconoColor = 'black';
                    break;
                    }
                    default:
                        this.iconoForma = 'mdi mdi-ghost';
                        this.iconoColor = 'black';
                    }
                } else {
                    Swal('Ups', response.Mensaje, 'info');
                }
            }, err => {
                console.log(err);
                Swal('Error', 'error del servidor, intentalo de nuevo o llama sistemas', 'error');
            }
        );
    }
    // Método llamado cuando el usuario tiene permisos pero el contrato aún no ha sido autorizado.
    swalSinAbastecimiento() {
        Swal('Error', 'No puedes crear un abastecimiento sin tener el contrato autorizado', 'error');
    }

    swalPermitirProrroga() {
        Swal('No permitido', 'No puedes realizar una reabastecimiento porque la fecha del alquiler aún está vigente', 'info');
    }

    documentoPopUp() {
        // idDocumento
        const autorizarCliente = this.permisosArray.find( permiso => permiso === 'CLIAUTO' );
        const autorizarDocumento = this.permisosArray.find( permiso => permiso === 'DOCAUTO' );
        this.currentIdDocumento = '';
        if (autorizarCliente) {
            this.mostrarBotones[0].autorizarClienteBtn = true;
        }
        if (autorizarDocumento) {
            this.mostrarBotones[0].autorizarDocumentoBtn = true;
        }
        // CONTRATO
        this.currentIdDocumento = this.estatusDocumentoId;
        this.imageSrc = this.API.contratos + this.documentoRuta;
        this.setInnerHtml(this.imageSrc);
        this.mostrarBotones[0].popUpHeaderText = 'CONTRATO';
    }

    actualizarContrato() {
        const actualizarContrato: FormData = new FormData();
        this.loginLoader = true;

        actualizarContrato.append('noContrato', this.contrato);
        // actualizarContrato.append('dias', this.dias);
        // actualizarContrato.append('fechaInicio', this.fechaInicio[0]);
        // actualizarContrato.append('fechaFin', this.fechaFin[0]);

        const fileUpload = $('#CONTRATO');
        actualizarContrato.append(fileUpload[0].id, fileUpload[0].files[0]);

        this.network.callSecureService(
            this.API.user.clientes + '/' + this.idCliente + '/' + this.API.user.contratos + '/' + this.API.user.actualizar,
            'POST', actualizarContrato).subscribe((response: any) => {
                // console.log(response);
                if ( response.Estatus === 201 ) {
                    Swal('Correcto', 'Se actualizó con éxito', 'success');
                    this.ruta.navigate(['dashboard/verCliente/' + this.idCliente + '/contratos/' + this.contrato + '/abastecimiento']);
                    // == Targets de notificación ==
                    let targets = response.Mensaje.notificacion;
                    targets.forEach(e => {
                        const target = e.target;
                        const id = e.id;
                        let notificacionString =  'El usuario ' + this.usuario.userName + ' ha actualizado un contrato.';
                        // let url = 'verCliente/' + response.Mensaje.cliente;
                        this.sendMessageTest(target, notificacionString, id);
                    });
                    // == Targets de notificación ==
                    /*
                    let targets = response.Mensaje.notificacion;
                    targets.forEach(e => {
                        const target = e.target;
                        this.sendMessageActualizarContrato(target);
                    });
                    */
                } else {
                    console.log( response.Mensaje );
                }
            }, err => {
                console.log( err );
                // Swal('Error', 'Ruta incorrecta', 'error');
            }
        );
    }

    getAbastecimientos() {
        const jsonData = {
            contratoId: Number(this.estatusDocumentoId)
        };
        console.log( jsonData  );
        this.network.callSecureService(
            this.API.user.clientes + '/' + this.API.user.contratos + '/' + this.API.user.abastecimientos,
            'POST',
            jsonData).subscribe((response: any) => {
                console.log(response);
                if (response.Estatus === 200) {
                    const responseMensaje = response.Mensaje.reverse();
                    let incremento = 1;
                    for (const contrato of responseMensaje) {
                        const fecha1 = contrato.fechaIncio.split('T');
                        const fecha2 = contrato.fechaFin.split('T');
                        this.globalFecha = contrato.fechaFin.split('T')[0];
                        this.globalConcepto = contrato.concepto;
                        this.diasAlquiler = contrato.dias;
                        // El siguiente if es utilizado para permitir o denegar un re-abastecimiento(prorroga).
                        // Verificará la fecha fin del alquiler
                        if ( this.globalConcepto === 'ALQUILER' ) {
                            // this.fechaHoy = moment().add('days', this.diasAlquiler).format('YYYY-MM-DD');
                            this.fechaHoy = moment().format('YYYY-MM-DD');
                            // console.log( 'Es un alquiler' );
                            // console.log( 'Días en alquiler: ' + this.diasAlquiler );
                            // Después compara fechas y finalmente la variable booleana btnPermitirProrroga cambia a true.
                            if (this.fechaHoy >= this.globalFecha) {
                                // >=
                                this.btnPermitirProrroga = false;
                                // console.log( 'Se terminó el alquiler' );
                                // console.log( 'Fecha fin alquiler: ' +  this.globalFecha );
                                // console.log( 'Fecha controlada: ' + this.fechaHoy );
                                this.btnPermitirUnaProrroga = true;
                            } else {
                                // this.swalPermitirProrroga();
                                this.btnPermitirProrroga = true;
                                // console.log( 'Alquiler vigente' );
                                // console.log( 'Fecha fin alquiler: ' +  this.globalFecha );
                                // console.log( 'Fecha controlada: ' + this.fechaHoy );
                                this.btnPermitirUnaProrroga = true;
                            }
                        }
                        this.contratosArray.push({
                        // id: this.incremento ++,
                        id: incremento++,
                        idAbas: contrato.idAbastecimiento,
                        concepto: contrato.concepto,
                        lapso: fecha1[0] + ' - ' + fecha2[0],
                        dias: contrato.dias,
                        estatusColor: contrato.estatus.color,
                        estatusNombre: contrato.estatus.nombre
                    });
                    // this.actualizarContrato();
                    // Siguiente IF para poder visualizar los botones de "Alquiler" y "Prorroga"
                    if (this.contratosArray.length <= 1) {
                        this.btnAlquiler = true;
                        this.btnProrroga = false;
                    } else {
                        this.btnAlquiler = true;
                        this.btnProrroga = false;
                    }
                }
                // this.actualizarContrato();
            } else {
                // Swal('Ups', response.Mensaje, 'info');
            }
            this.dtTrigger.next();
            }, err => {
                console.log(err);
                Swal('Atención', 'Aún no tienes abastecimientos que pertenezcan a este contrato', 'info');
            }
        );
    }

    inverse() {
        this.clientesArrayReverse = this.contratosArray.reverse();
    }
    // Cambia de color el boton de ver documento
    cambiarEstatusDocumento (codFuncion) {
        const jsonData = {
            idDocumento: this.currentIdDocumento,
            estatus: codFuncion,
            tipoDocumento: 'CONTRATO',
            noContrato: this.urlContrato
        };
        // console.log( this.urlContrato );
        this.network.callSecureService(
            this.API.user.clientes + '/' + this.API.user.garantias + '/' + this.API.user.autorizar,
            'POST',
            jsonData )
            .subscribe((response: any) => {
                // console.log(response);
                if ( response.Estatus === 201 ) {
                // response.Mensaje.estatus
                    if (codFuncion === 'AUTCOMP') {
                        Swal('Correcto', response.Mensaje.strings, 'success');
                        /*
                        let targets = response.Mensaje[0].notificacion;
                        targets.forEach(e => {
                            const target = e.target;
                            this.sendMessage(target);
                        });
                        */
                        // == Targets de notificación ==
                        let targets = response.Mensaje[0].notificacion;
                        targets.forEach(e => {
                            const target = e.target;
                            const id = e.id;
                            let notificacionString =  'El usuario ' + this.usuario.userName + ' ha aceptado un contrato.';
                            // let url = 'verCliente/' + response.Mensaje.cliente;
                            this.sendMessageTest(target, notificacionString, id);
                        });
                        // == Targets de notificación ==
                        this.detallesContrato();
                        // this.ruta.navigate(['dashboard/verCliente', this.idCliente, 'contratos', this.urlContrato, 'abastecimiento']);
                        // response.Mensaje.estatus.nombre
                    } else if (codFuncion === 'AUTDENE') {
                        Swal('Correcto', response.Mensaje.strings, 'error');
                        /*
                        let targets = response.Mensaje.notificacion;
                        targets.forEach(e => {
                            const target = e.target;
                            this.sendMessageRechazado(target);
                        });
                        */
                        // == Targets de notificación ==
                        let targets = response.Mensaje.notificacion;
                        targets.forEach(e => {
                            const target = e.target;
                            const id = e.id;
                            let notificacionString =  'El usuario ' + this.usuario.userName + ' ha rechazado un contrato.';
                            // let url = 'verCliente/' + response.Mensaje.cliente;
                            this.sendMessageTest(target, notificacionString, id);
                        });
                        // == Targets de notificación ==
                        this.detallesContrato();
                    }
                } else {
                    Swal('Atención', response.Mensaje, 'warning');
                }
            }, err => {
                // console.log(err);
                Swal('Error', this.GENERALES.algoOcurrio, 'error');
                // Swal( 'Error', 'Algo anda mal...', 'error' );
            }
        );
    }
    // Comentario de Contrato
    enviarComentarioContrato () {
        this.enviandoMensajeComentarioPopUp = true;
        const jsonData = {
            idContrato: this.estatusDocumentoId,
            comentario: this.currentMensajeComentarioPopUp
        };
        // this.detallesContrato();
        this.network.callSecureService(
            this.API.user.clientes + '/' + this.API.user.contratos + '/' + this.API.user.agregarComentario,
            'POST',
            jsonData )
            .subscribe((response: any) => {
                // console.log(response);
                this.enviandoMensajeComentarioPopUp = false;
                this.currentMensajeComentarioPopUp = '';
                this.detallesContrato();
            }, err => {
                // console.log(err);
                this.enviandoMensajeComentarioPopUp = false;
                Swal('Error', this.GENERALES.algoOcurrio, 'error');
            }
        );
    }

    selectedRowClient (id: any) {
        // console.log(info);
        const permisoVerCliente = this.permisosArray.find( permiso => permiso === 'CONVER' );
        if (permisoVerCliente) {
            // En el siguiente router.navigate es utilizado para dirigir a la página y mostrar los mivimientos disponibles con dicho contrato.
            // En router.navigate se utiliza info[1], porque necesitamos el folio del contrato que ya se muestra en el datatable.
            this.ruta.navigate(['dashboard/verCliente', this.idCliente, 'contratos', this.urlContrato, 'abastecimiento', id]);
        } else {
            Swal('Error', this.GENERALES.noTienePermisos, 'error');
        }
    }

    alquiler() {
        this.ruta.navigate(['dashboard/verCliente', this.idCliente, 'contratos', this.contrato, 'abastecimiento', 'alquiler']);
    }
    prorroga() {
        this.ruta.navigate(['dashboard/verCliente', this.idCliente, 'contratos', this.contrato, 'abastecimiento', 'reabastecimiento']);
    }
    venta() {
        this.ruta.navigate(['dashboard/verCliente', this.idCliente, 'contratos', this.contrato, 'abastecimiento', 'venta']);
    }

    mostrarBotonesAbastecimiento () {
        const permisoCrearCliente = this.permisosArray.find( permiso => permiso === 'ABACREA' );
        if (permisoCrearCliente) {
            this.botonesPermisos.crearAbastecimiento = true;
            // document.getElementById('botonCrearCliente').style.opacity = '1';
        } else {
            // Swal('Error', this.GENERALES.noTienePermisos, 'error');
            // this.router.navigate(['/dashboard']);
        }
        const permisoActualizarContrato = this.permisosArray.find( permiso => permiso === 'CONEDIT' );
    }

    IdAbastecimiento(id: any) {
        this.selectedRowClient(id);
    }

    // Funcion para enviar mensajes (por ahora notificaciones)
    sendMessageTest(target, notificacionString, id) {
        let mensaje = {
          mensaje: notificacionString,
          usuario: this.usuario.userName,
          target: target,
          tipo: 'notificacion',
          // url: url,
          id: id
        };
       this.chat.sendMsg(mensaje);
    }

    sendMessage(target) {
        let mensaje = {
            mensaje: 'El usuario ' + this.usuario.userName + ' ha aceptado un contrato',
            usuario: this.usuario.userName,
            target: target,
            tipo: 'notificacion'
        };
        this.chat.sendMsg(mensaje);
    }

    sendMessageRechazado(target) {
        let mensaje = {
            mensaje: 'El usuario ' + this.usuario.userName + ' ha rechazado un contrato',
            usuario: this.usuario.userName,
            target: target,
            tipo: 'notificacion'
        };
        this.chat.sendMsg(mensaje);
    }

    sendMessageActualizarContrato(target) {
        let mensaje = {
            mensaje: 'El usuario ' + this.usuario.userName + ' ha actualizado un contrato',
            usuario: this.usuario.userName,
            target: target,
            tipo: 'notificacion'
        };
        this.chat.sendMsg(mensaje);
    }

    public setInnerHtml(pdfurl: string) {
        this.innerHtml = this.sanitizer.bypassSecurityTrustHtml(
            "<object data='" + pdfurl + "' type='application/pdf' style='width:100%; height: 400px;'>" +
            'Object ' + pdfurl + ' failed' +
            '</object>');
    }

    comentarioDoble() {
        const comentario = this.comentariosContratoArray[this.comentariosContratoArray.length -1 ];
        this.visto = false;

        const jsonData = {
            comentarioId: comentario.comentarioId,
            tipoDocumento: 'CONTRATO'
        };
        this.network.callSecureService(
            // url
            'garantias/visto',
            // metodo
            'POST',
            // contentType
            jsonData
            ).subscribe((response) => {
                // console.log(response);
        }, err => {
            // console.log(err);
        });
    }


}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/cliente/listar-abastecimiento/listar-abastecimiento.component.ts